
import { simulateModel, simulatorLabel, simReset, sidecarIsBusy, circuitCheckIsNeeded } from "./ModelHelpers.js";
import { Model, currentStepSimulationStep_, TTMsg, SimSubTab, Msg } from "../Model/ModelType.js";
import { DrawModelType_SheetT_Model__Model_GetCanvasState } from "../DrawBlock/Sheet.js";
import { notifyMemoryFileErrors, updateAllMemoryComps } from "./MemoryEditorView.js";
import { getSimErrFeedbackMessages, InputDefaultsEqualInputsRefresh, setInputDefaultsFromInputs, InputDefaultsEqualInputs, viewSimulationError, viewSimulationData, advanceTo, setSimErrorFeedback, tryGetSimData } from "./SimulationView.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { addStateToLoadedComponents } from "../Simulator/CanvasExtractor.js";
import { storedstateisEqual, SimCache, simCache as simCache_1 } from "../Simulator/Simulator.js";
import * as react from "react";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { Option, button } from "../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { Color_IColor } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { append, map, empty, ofArray, singleton } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { emptyRefreshSVG, refreshSvg } from "./Style.js";
import { dialogPopupRefresh } from "../DrawBlock/PopupHelpers.js";
import { equals } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { Cmd_batch } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { extractConnections } from "../DrawBlock/BusWire.js";
import { extractComponents } from "../DrawBlock/SymbolUpdate.js";
import { Optic_Set, Optic_Set_op_HatEquals_Z147477F8 } from "../Common/Optics.js";

export function viewSimulation(canvasState_, canvasState__1, model, dispatch) {
    let props_32, children_20, props_24, children_16, props_28, s_10;
    const canvasState = [canvasState_, canvasState__1];
    if (circuitCheckIsNeeded(model, canvasState[0], canvasState[1])) {
        dispatch(Msg.RequestCircuitCheck);
    }
    let verdict;
    const option_1 = model.CircuitCheck.Verdict;
    verdict = ((option_1 != null) ? option_1[0] : undefined);
    const buildsOk = (verdict != null) ? (!(verdict.tag === 1)) : true;
    let isLoading;
    const matchValue_2 = model.RunAfterRenderWithSpinner;
    let matchResult;
    if (matchValue_2 != null) {
        if (matchValue_2.ButtonSpinnerOn) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            isLoading = true;
            break;
        }
        default:
            isLoading = false;
    }
    const startSimulationWithSpinner = (afterwards) => {
        dispatch(new Msg(/* RunAfterRender */ 126, [[true, (_arg_1) => ((model_4) => {
            let _arg, simError;
            const model_1 = model_4;
            const canvasState_1 = DrawModelType_SheetT_Model__Model_GetCanvasState(model_1.Sheet);
            const model_2 = updateAllMemoryComps(model_1);
            notifyMemoryFileErrors(dispatch, model_2);
            dispatch(new Msg(/* StartSimulation */ 10, [(_arg = tryGetSimData(false, canvasState_1[0], canvasState_1[1], model_2), (_arg.tag === 1) ? ((simError = _arg.fields[0], (setSimErrorFeedback(simError, model_2, dispatch), new FSharpResult$2(/* Error */ 1, [simError])))) : (new FSharpResult$2(/* Ok */ 0, [_arg.fields[0]])))]));
            const matchValue = model_2.CurrentProj;
            if (matchValue == null) {
            }
            else {
                const project = matchValue;
                const ldcs = addStateToLoadedComponents(simCache_1().Name, canvasState_1[0], canvasState_1[1], project.LoadedComponents);
                simCache_1(new SimCache(simCache_1().Name, simCache_1().ClockTickRefresh, ldcs, simCache_1().StoredResult, simCache_1().FastSim));
            }
            afterwards(model_4);
            return model_4;
        })]]));
    };
    const matchValue_3 = model.CurrentStepSimulationStep;
    if (matchValue_3 != null) {
        const sim = matchValue_3;
        let canvasStateChange;
        const currentCanvasState = canvasState;
        const simCache = simCache_1();
        const matchValue_1 = model.CurrentProj;
        canvasStateChange = ((matchValue_1 != null) && !storedstateisEqual(simCache, addStateToLoadedComponents(simCache.Name, currentCanvasState[0], currentCanvasState[1], matchValue_1.LoadedComponents)));
        let body;
        if (sim.tag === 0) {
            const simData_1 = sim.fields[0];
            if (((simData_1.ClockTickNumber === 0) && (simCache_1().ClockTickRefresh !== 0)) && !sidecarIsBusy(model)) {
                const clock = simCache_1().ClockTickRefresh | 0;
                simCache_1(new SimCache(simCache_1().Name, 0, simCache_1().StoredState, simCache_1().StoredResult, simCache_1().FastSim));
                advanceTo(model, simData_1, clock, dispatch, (reached) => {
                    dispatch(new Msg(/* IncrementSimulationClockTick */ 27, [reached]));
                });
            }
            body = viewSimulationData(simData_1.ClockTickNumber, simData_1, model, dispatch);
        }
        else {
            const props_8 = [["style", {
                flex: "1 1 auto",
                minHeight: "0px",
                overflowY: "auto",
            }]];
            const children_2 = [viewSimulationError(canvasState[0], canvasState[1], sim.fields[0], model, SimSubTab.StepSim, dispatch)];
            body = react.createElement("div", keyValueList(props_8, 1), ...children_2);
        }
        let setDefaultButton;
        if (sim.tag === 0) {
            const simData_2 = sim.fields[0];
            setDefaultButton = button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsInfo]), new Option(/* Disabled */ 16, [InputDefaultsEqualInputs(simData_2.FastSim, model, simData_2.ClockTickNumber)]), new Option(/* OnClick */ 18, [(_arg_3) => {
                setInputDefaultsFromInputs(model, simData_2.FastSim, dispatch, simData_2.ClockTickNumber);
            }]), new Option(/* Props */ 17, [singleton(["style", {
                display: "inline",
                float: "right",
            }])])]), singleton("Save current input values as default"));
        }
        else {
            setDefaultButton = react.createElement("div", {});
        }
        const patternInput_1 = buildsOk ? [Color_IColor.IsSuccess, refreshSvg("white", "20px")] : [Color_IColor.IsWarning, "See Problems"];
        const buttonIcon = patternInput_1[1];
        const buttonColor_1 = patternInput_1[0];
        const createRefreshButton = (buttonColor_2, buttonIcon_1, onClick) => button(ofArray([new Option(/* Color */ 0, [buttonColor_2]), new Option(/* IsLoading */ 13, [isLoading]), new Option(/* OnClick */ 18, [onClick]), new Option(/* Props */ 17, [singleton(["style", {
            display: "inline",
            float: "none",
            marginLeft: "5px",
        }])])]), singleton(buttonIcon_1));
        const startSimulationUpdateCache = (clock_3) => {
            startSimulationWithSpinner((_arg_8) => {
                simCache_1(new SimCache(simCache_1().Name, clock_3, simCache_1().StoredState, simCache_1().StoredResult, simCache_1().FastSim));
            });
        };
        const createRefreshButtonError = createRefreshButton(buttonColor_1, buttonIcon, (_arg_11) => {
            startSimulationUpdateCache(simCache_1().ClockTickRefresh);
        });
        let refreshButton;
        if (canvasStateChange) {
            if (sim.tag === 1) {
                refreshButton = createRefreshButtonError;
            }
            else {
                const sim_1 = sim;
                const dispatch_2 = dispatch;
                if (sim_1.tag === 0) {
                    const simData_4 = sim_1.fields[0];
                    refreshButton = (InputDefaultsEqualInputsRefresh(simData_4.FastSim, model, simData_4.ClockTickNumber) ? createRefreshButton(buttonColor_1, buttonIcon, (_arg_9) => {
                        startSimulationUpdateCache(simData_4.ClockTickNumber);
                    }) : createRefreshButton(buttonColor_1, buttonIcon, (_arg_10) => {
                        let dispatch_1, simData_3;
                        if (buildsOk) {
                            dialogPopupRefresh("Refresh", (dispatch_1 = dispatch_2, (simData_3 = simData_4, (model_6) => {
                                let props_14, children_8, props_12, children_6, s_4, props_16, props_20, children_12, props_18;
                                const children_14 = [(props_14 = [["style", {
                                    height: "60px",
                                    display: "block",
                                    marginBottom: "5px",
                                }]], (children_8 = [(props_12 = [["style", {
                                    width: "80%",
                                    float: "left",
                                }]], (children_6 = [(s_4 = "Refresh the simulation using current values of the inputs and the latest design? \r\n                    The current values will be used as default for future simulations.", s_4)], react.createElement("h6", keyValueList(props_12, 1), ...children_6))), button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsSuccess]), new Option(/* OnClick */ 18, [(_arg_4) => {
                                    const clock_1 = simData_3.ClockTickNumber | 0;
                                    setInputDefaultsFromInputs(model_6, simData_3.FastSim, dispatch_1, clock_1);
                                    dispatch_1(Msg.ClosePopup);
                                    startSimulationWithSpinner((_arg_5) => {
                                        simCache_1(new SimCache(simCache_1().Name, clock_1, simCache_1().StoredState, simCache_1().StoredResult, simCache_1().FastSim));
                                    });
                                }]), new Option(/* Props */ 17, [singleton(["style", {
                                    display: "inline",
                                    float: "right",
                                    marginTop: "10px",
                                }])])]), singleton("Ok"))], react.createElement("div", keyValueList(props_14, 1), ...children_8))), (props_16 = [["style", {
                                    width: "100%",
                                    float: "left",
                                }]], react.createElement("hr", keyValueList(props_16, 1))), (props_20 = [["style", {
                                    height: "50px",
                                    display: "block",
                                }]], (children_12 = [(props_18 = [["style", {
                                    width: "80%",
                                    float: "left",
                                }]], react.createElement("h6", keyValueList(props_18, 1), "Refresh the simulation using default values of inputs, current values will be lost.")), button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsInfo]), new Option(/* OnClick */ 18, [(_arg_6) => {
                                    dispatch_1(Msg.ClosePopup);
                                    startSimulationWithSpinner((_arg_7) => {
                                        simCache_1(new SimCache(simCache_1().Name, simData_3.ClockTickNumber, simCache_1().StoredState, simCache_1().StoredResult, simCache_1().FastSim));
                                    });
                                }]), new Option(/* Props */ 17, [singleton(["style", {
                                    display: "inline",
                                    float: "right",
                                }])])]), singleton("Reset"))], react.createElement("div", keyValueList(props_20, 1), ...children_12)))];
                                return react.createElement("div", {}, ...children_14);
                            })), empty(), dispatch_2);
                        }
                        else {
                            startSimulationUpdateCache(simData_4.ClockTickNumber);
                        }
                    }));
                }
                else {
                    refreshButton = emptyRefreshSVG;
                }
            }
        }
        else {
            refreshButton = emptyRefreshSVG;
        }
        const props_34 = [["style", {
            flex: "1 1 auto",
            minHeight: "0px",
            display: "flex",
            flexDirection: "column",
        }]];
        const children_22 = [(props_32 = [["style", {
            flex: "0 0 auto",
        }]], (children_20 = [(props_24 = [["style", {
            height: "40px",
        }]], (children_16 = [button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsDanger]), new Option(/* OnClick */ 18, [(_arg_12) => {
            simReset(dispatch);
            dispatch(Msg.EndSimulation);
        }]), new Option(/* Props */ 17, [singleton(["style", {
            display: "inline",
            float: "left",
        }])])]), singleton("End simulation")), refreshButton, setDefaultButton], react.createElement("div", keyValueList(props_24, 1), ...children_16))), react.createElement("br", {}), (props_28 = [["style", {
            display: "block",
        }]], react.createElement("div", keyValueList(props_28, 1))), (s_10 = "The simulation uses the diagram as it was at the moment of\r\n                     pressing the \"Start simulation\" or \"Refresh\" button using default input values.", s_10), react.createElement("hr", {})], react.createElement("div", keyValueList(props_32, 1), ...children_20))), body];
        return react.createElement("div", keyValueList(props_34, 1), ...children_22);
    }
    else {
        const isSync = equals(verdict, new FSharpResult$2(/* Ok */ 0, [true]));
        const patternInput = buildsOk ? [Color_IColor.IsSuccess, "Start Simulation" + simulatorLabel(model)] : [Color_IColor.IsWarning, "See Problems"];
        const children = ["Simulate simple logic using this tab.", react.createElement("br", {}), isSync ? "You can also use the Wave Simulation tab to view waveforms" : "", react.createElement("br", {}), react.createElement("br", {}), button(ofArray([new Option(/* Color */ 0, [patternInput[0]]), new Option(/* IsLoading */ 13, [isLoading]), new Option(/* OnClick */ 18, [(_arg_2) => {
            startSimulationWithSpinner((value) => {
            });
        }])]), singleton(patternInput[1]))];
        return react.createElement("div", {}, ...children);
    }
}

export function tryStartSimulationAfterErrorFix(simType, model) {
    const withMsg = (msg, model_1) => [model_1, singleton((dispatch) => {
        dispatch(msg);
    })];
    const withMsgs = (msgs, model_2) => [model_2, Cmd_batch(map((msg_2) => singleton((dispatch_1) => {
        dispatch_1(msg_2);
    }), msgs))];
    const withCmdTTMsg = (ttMsg, model_3) => [model_3, singleton((dispatch_2) => {
        dispatch_2(new Msg(/* TruthTableMsg */ 32, [ttMsg]));
    })];
    const conns = extractConnections(model.Sheet.Wire);
    const canvasState = [extractComponents(model.Sheet.Wire.Symbol), conns];
    const simErrFeedback = (simErr, otherMsg) => append(getSimErrFeedbackMessages(simErr, model), singleton(otherMsg));
    switch (simType.tag) {
        case 1: {
            const _arg_1 = simulateModel(true, false, undefined, 2, canvasState[0], canvasState[1], model);
            const copyOfStruct = _arg_1[0];
            if (copyOfStruct.tag === 1) {
                return withMsgs(simErrFeedback(copyOfStruct.fields[0], new Msg(/* TruthTableMsg */ 32, [new TTMsg(/* GenerateTruthTable */ 0, [[new FSharpResult$2(/* Error */ 1, [copyOfStruct.fields[0]]), _arg_1[1]]])])), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, currentStepSimulationStep_)(new FSharpResult$2(/* Error */ 1, [copyOfStruct.fields[0]]))(model));
            }
            else if (copyOfStruct.fields[0].IsSynchronous === false) {
                return withCmdTTMsg(new TTMsg(/* GenerateTruthTable */ 0, [[new FSharpResult$2(/* Ok */ 0, [copyOfStruct.fields[0]]), _arg_1[1]]]), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, currentStepSimulationStep_)(new FSharpResult$2(/* Ok */ 0, [copyOfStruct.fields[0]]))(model));
            }
            else {
                return withCmdTTMsg(TTMsg.CloseTruthTable, new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, undefined, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, model.CurrentProj, model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, model.CodeEditorState));
            }
        }
        case 2:
            return withMsg(Msg.StartWaveSimulation, model);
        default: {
            const _arg = tryGetSimData(false, canvasState[0], canvasState[1], model);
            if (_arg.tag === 1) {
                const simError = _arg.fields[0];
                return withMsgs(simErrFeedback(simError, new Msg(/* StartSimulation */ 10, [new FSharpResult$2(/* Error */ 1, [simError])])), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, currentStepSimulationStep_)(new FSharpResult$2(/* Error */ 1, [simError]))(model));
            }
            else {
                const simData = _arg.fields[0];
                return withMsg(new Msg(/* StartSimulation */ 10, [new FSharpResult$2(/* Ok */ 0, [simData])]), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, currentStepSimulationStep_)(new FSharpResult$2(/* Ok */ 0, [simData]))(model));
            }
        }
    }
}

